import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "../../admin_resources/css/admin_layout.css";
import "../../admin_resources/css/admin_common.css";
import loginButton from "../../admin_resources/img/login_button.png";
import regsitButton from "../../admin_resources/img/regist_button.png";
import { Link } from "react-router-dom";
import axios from "axios";

const Admin_login = () => {
  const [adminId, setAdminId] = useState("");
  const [adminPwd, setAdminPwd] = useState("");
  const [isIdFocused, setIsIdFocused] = useState(false);
  const [isPwdFocused, setIsPwdFocused] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    document.title = ":_:아소비 관리자 로그인 :_:";

    // 초기화
    localStorage.removeItem("adminName");
    localStorage.removeItem("adminDept");
    localStorage.removeItem("adminSuper");

    // localStorage에서 아이디/비밀번호 복원
    const savedId = localStorage.getItem("adminId");
    const savedPwd = localStorage.getItem("adminPwd");

    if (savedId) setAdminId(savedId);
    if (savedPwd) setAdminPwd(savedPwd);
  }, []);

  const fetchPermissions = async (adminId) => {
    try {
      const response = await axios.get(`/permissions/${adminId}`);
      console.log("Fetched Permissions (API Response):", response.data);
      return response.data; // 서버에서 반환된 권한 데이터
    } catch (error) {
      console.error("권한 데이터를 가져오는 중 오류 발생:", error);
      return {};
    }
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    try {
      const loginResponse = await axios.post("/login", { adminId, adminPwd });

      if (loginResponse.status === 200) {
        localStorage.setItem("adminId", adminId);
        localStorage.setItem("adminPwd", adminPwd);

        const adminData = loginResponse.data;
        localStorage.setItem("adminName", adminData.adminName);
        localStorage.setItem("adminDept", adminData.adminDept);
        localStorage.setItem("adminSuper", adminData.adminSuper);

        const permissions = await fetchPermissions(adminId); // 권한 데이터 가져오기
        console.log("Fetched Permissions:", permissions);

        const menuPermissions = [
          { key: "banner", path: "/admin/site/banner" },
          { key: "popup", path: "/admin/site/popup" },
          { key: "notice", path: "/admin/board/notice" },
          { key: "event", path: "/admin/board/event" },
          { key: "social", path: "/admin/board/social" },
          { key: "magazine", path: "/admin/board/magazine" },
          { key: "ent", path: "/admin/form/ent" },
          { key: "fr", path: "/admin/form/fr" },
          { key: "franchise", path: "/admin/form/franchise" },
          { key: "schedule", path: "/admin/form/schedule" },
          { key: "jisa", path: "/admin/form/jisa" },
          { key: "q", path: "/admin/form/q" },
          { key: "etc_q", path: "/admin/form/etc_q" },
        ];

        // 권한이 있는 첫 번째 메뉴로 이동
        for (let i = 0; i < menuPermissions.length; i++) {
          const permissionKey = menuPermissions[i].key;
          if (permissions[permissionKey]) {
            navigate(menuPermissions[i].path, {
              state: { adminName: adminData.adminName },
            });
            return;
          }
        }

        alert("권한이 없습니다. 관리자에게 문의하세요.");
      }
    } catch (error) {
      if (error.response && error.response.status === 403) {
        alert(
          "아직 회원가입 수락이 완료되지 않았습니다. 관리자(IT팀 이지우)에게 문의하세요."
        );
      } else {
        alert("아이디 또는 비밀번호가 잘못되었습니다.");
      }
    }
  };

  return (
    <div>
      <div id="mvisual">
        <div id="greet"></div>
        <div id="login_container"></div>
        <div className="wrap">
          <h3>
            <font>관리자 페이지 로그인</font>
          </h3>
          <br />
          <br />
          <form onSubmit={handleSubmit}>
            <fieldset id="login_level">
              <legend>로그인</legend>

              <table className="tbl_login" cellspacing="0" summary="로그인">
                <caption>로그인</caption>
                <colgroup>
                  <col />
                </colgroup>
                <tbody>
                  <tr>
                    <td>
                      <input
                        type="text"
                        id="admin_id"
                        name="admin_id"
                        title="ID"
                        className="input_uid"
                        tabindex="1"
                        placeholder="   아이디 입력"
                        value={adminId}
                        onChange={(e) => setAdminId(e.target.value)}
                        onFocus={() => setIsIdFocused(true)}
                        onBlur={() => setIsIdFocused(false)}
                        style={{
                          backgroundColor:
                            isIdFocused || adminId ? "#e4f2fe" : "#fff",
                        }}
                      />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <input
                        type="password"
                        id="admin_pwd"
                        name="admin_pwd"
                        title="PW"
                        className="input_uid"
                        tabindex="2"
                        placeholder="   비밀번호 입력"
                        value={adminPwd}
                        onChange={(e) => setAdminPwd(e.target.value)}
                        onFocus={() => setIsPwdFocused(true)}
                        onBlur={() => setIsPwdFocused(false)}
                        style={{
                          backgroundColor:
                            isPwdFocused || adminPwd ? "#e4f2fe" : "#fff",
                        }}
                      />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <button type="submit">
                        <img src={loginButton} id="Login_btn" alt="로그인" />
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </fieldset>
          </form>
          <div>
            <Link to="/admin/admin_regist">
              <img src={regsitButton} id="Regist_btn" alt="신규등록" />
            </Link>
          </div>
          <br />
          <br />
          <br />
          <div className="sec-footer">
            <font>
              <strong>Copyrightⓒ ASOBI EDUCATION All Rights Reserved.</strong>
            </font>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Admin_login;
